import React, { useEffect, useLayoutEffect, useState } from 'react';
import { X } from 'lucide-react';

const TOUR_COPY = {
  clinic_configured: { selector: '[data-onboarding-id="onboarding-page-content"]', title: 'Complete as configurações essenciais', text: 'Revise as abas Dados Básicos, Profissionais, Especialidades, Documentos e Horários. Salve as alterações para concluir esta etapa.' },
  patient_created: { selector: '[data-onboarding-id="new-patient"]', title: 'Cadastre um paciente', text: 'Use este botão para abrir o cadastro. A etapa só será concluída depois que o paciente for salvo.' },
  appointment_created: { selector: '[data-onboarding-id="new-appointment"]', title: 'Crie um agendamento', text: 'Comece por “Novo Agendamento”, escolha o paciente e confirme data e horário.' },
  anamnese_completed: { selector: '[data-onboarding-id="fill-anamnese"]', title: 'Preencha ou envie a anamnese', text: 'Nesta aba você pode preencher com o paciente. O envio público também conclui a conquista.' },
  document_created: { selector: '[data-onboarding-id="new-clinical-document"]', title: 'Gere um documento', text: 'Abra um novo documento, escolha o paciente e salve. Apenas abrir o editor não conclui a etapa.' },
  contextual_ai_used: { selector: '[data-onboarding-id="onboarding-page-content"]', title: 'IA dentro do contexto clínico', text: 'Abra um prontuário e utilize uma das revisões de IA disponíveis em anamnese, evolução, odontograma, documentos ou resumo.' },
  financial_entry_created: { selector: '[data-onboarding-id="onboarding-page-content"]', title: 'Inicie o Financeiro', text: 'Registre uma fatura, receita externa ou despesa. Qualquer uma dessas ações conclui esta etapa.' },
};

const GuidedTour = () => {
  const [tour, setTour] = useState(null);
  const [rect, setRect] = useState(null);

  useEffect(() => {
    const start = (event) => setTour(TOUR_COPY[event.detail?.stepId] || null);
    window.addEventListener('odontoassist:start-guided-tour', start);
    return () => window.removeEventListener('odontoassist:start-guided-tour', start);
  }, []);

  useLayoutEffect(() => {
    if (!tour) return undefined;
    let attempts = 0;
    const locate = () => {
      const target = document.querySelector(tour.selector);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setRect(target.getBoundingClientRect());
      } else if (attempts++ < 12) window.setTimeout(locate, 150);
    };
    locate();
    const update = () => {
      const target = document.querySelector(tour.selector);
      if (target) setRect(target.getBoundingClientRect());
    };
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, [tour]);

  if (!tour) return null;
  const top = rect ? Math.min(window.innerHeight - 210, Math.max(16, rect.bottom + 12)) : '50%';
  const left = rect ? Math.min(window.innerWidth - 360, Math.max(16, rect.left)) : '50%';

  return <div className="fixed inset-0 z-[70] bg-black/45" role="dialog" aria-modal="true" aria-label={tour.title}>
    {rect && <div className="pointer-events-none fixed rounded-lg ring-4 ring-indigo-400 ring-offset-4 ring-offset-white" style={{ top: rect.top, left: rect.left, width: rect.width, height: rect.height }} />}
    <div className="fixed max-w-sm rounded-xl bg-white p-5 shadow-2xl" style={{ top, left, width: 'calc(100% - 2rem)', transform: rect ? 'none' : 'translate(-50%, -50%)' }}>
      <button type="button" onClick={() => setTour(null)} className="absolute right-3 top-3 rounded p-1 text-gray-500 hover:bg-gray-100" aria-label="Fechar orientação"><X className="h-5 w-5" /></button>
      <p className="pr-8 text-lg font-bold text-gray-900">{tour.title}</p>
      <p className="mt-2 text-sm leading-6 text-gray-600">{tour.text}</p>
      <button type="button" onClick={() => setTour(null)} className="mt-4 rounded-lg bg-indigo-600 px-4 py-2 text-sm font-semibold text-white hover:bg-indigo-700">Entendi</button>
    </div>
  </div>;
};

export default GuidedTour;
